<template>
  <div class="article-below-body__wrapper">
    <a-article-tags-list
      v-if="article.tags.length"
      :tags="article.tags"
      class="article-below-body__tag-list"
    />
    <article-social-icons
      v-on="$listeners"
      :article="article"
      class="article-below-body__share-socials top-margin"
    />
    <a-visibility v-if="showDisclaimer" show :on="[$breakpoint.mobile]">
      <div class="article-below-body__bottom-disclaimer-wrapper">
        <a-disclaimer
          :layout-ordering="$options.consts.bottomDisclaimerLayoutOrdering"
          class="article-below-body__bottom-disclaimer top-margin"
        />
      </div>
    </a-visibility>
    <div
      :data-ref="$options.consts.REFS.ARTICLE_PAGE_DISQUS_WIDGET"
      id="article-below-body__disqus-section"
      class="top-margin"
    >
      <a-vue-disqus
        :title="article.title"
        :identifier="article.id"
        :url="article.canonicalUrl"
        :category_id="$env.FM_DISQUS_ARTICLE_ID"
      />
    </div>
    <article-about-publisher
      v-if="!isCompany && article.publishers[0]"
      :publisher="article.publishers[0]"
      class="article-below-body__about-publisher top-margin"
    />
    <article-about-publisher
      v-if="!isCompany && article.publishers[1]"
      :publisher="article.publishers[1]"
      class="article-below-body__about-publisher top-margin"
    />
    <!-- Sync with ArticleSidebar/index.vue -->
    <a-visibility show :to="$breakpoint.desktopMd" :keep-on-client="false">
      <a-buzz-sprout-player class="article-below-body__buzz-widget" />
    </a-visibility>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import mixins from '@/utils/mixins'
import AArticleTagsList from '@/components/_sections/article/AArticleTagsList'
import AVueDisqus from 'shared/AVueDisqus/lazy.vue'
import ArticleSocialIcons from './ArticleSocialIcons'
import ArticleAboutPublisher from './ArticleAboutPublisher'
import { REFS } from 'enums/external-refs'
import ADisclaimer from 'shared/ADisclaimer'
import { LAYOUT as DISCLAIMER_LAYOUT } from 'shared/ADisclaimer/enums'
import ABuzzSproutPlayer from 'shared/ABuzzSproutPlayer/index.vue'
import AVisibility from 'shared/AVisibility/index.vue'

export default {
  name: 'ArticleBelowBody',
  mixins: [mixins.urlGenerators],
  components: {
    AVisibility,
    ABuzzSproutPlayer,
    ADisclaimer,
    AVueDisqus,
    AArticleTagsList,
    ArticleSocialIcons,
    ArticleAboutPublisher
  },
  props: {
    article: propValidator([PROP_TYPES.OBJECT]),
    showDisclaimer: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    REFS,
    bottomDisclaimerLayoutOrdering: [DISCLAIMER_LAYOUT.TOP_CENTER]
  },
  computed: {
    isCompany() {
      return !!this.article.sponsorshipCompany
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/styles/article';

.article-below-body__wrapper {
  .article-below-body__tag-list {
    margin-top: 20px;
  }

  .article-below-body__buzz-widget {
    margin-top: 15px;
  }

  .article-below-body__bottom-disclaimer-wrapper {
    display: flex;
    justify-content: center;
  }

  .article-below-body__bottom-disclaimer {
    display: inline-block;
  }

  .top-margin {
    margin-top: 20px;
  }
}
</style>
